// extracted by mini-css-extract-plugin
export default {"body":"App_body__CNzrK","app":"App_app__GBfMf","main":"App_main__QRFxq"};